/**
 * Ambiente de execucao.
 *
 * Nao existe uma variavel dedicada: o que distingue os ambientes e o rotulo de
 * versao (os `.env.app` de `k8s/overlays`), que sai como `0.0.0-dev`,
 * `0.0.0-hml` e `1.0.0-prod` nos dois tenants de producao.
 *
 * A leitura e FECHADA por padrao: rotulo ausente conta como producao. Uma tela
 * so de desenvolvimento escondida por engano custa um ajuste; exposta por
 * engano num build mal configurado, custa mais.
 */
export function isProductionEnvironment() {
  /* Servidor Vite local nunca e producao, qualquer que seja o rotulo — o .env
     da maquina costuma herdar o de homologacao. */
  if (import.meta.env.DEV) return false;

  const versao = import.meta.env.VUE_APP_APP_VERSION;

  if (!versao) return true;

  return /prod/i.test(versao);
}

export default { isProductionEnvironment };
